import MyAccess from './MyAccess'

export default MyAccess
